<template>
  <div class="container">
    <Modal @closeDialog="visible = false" :visible="visible" :errorMessage="resultMessage"></Modal>
    <div v-if="loading" class="fa-3x col-md-offset-6">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <div class="col-md-offset-4 col-md-4 col-xs-12">
      <div class="card mb-3" v-for="(user, index) in users">
        <div class="card-body">
          <h2 class="card-title">User information</h2>
          <span class="float-right" style="cursor:pointer" @click="deleteUserForm(index)"> X</span>
          <form>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="First name" v-model="user.first_name" />
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Last name" v-model="user.last_name" />
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Email" v-model="user.email" />
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Password" v-model="user.password" />
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="custom-select">
                    <select class="form-control"  v-model="user.userType" :required = true>
                      <option disabled value="">Select User Type</option>
                      <option>Bulk Data Sales Client</option>
                      <option>Staff</option>
                      <option>API Key Client</option>
                      <option>Local Candidate Researcher</option>
                      <option>Local Candidate Campaign Themes Researcher</option>
                      <option>Local Candidate Endorsement Researcher</option>
                      <option>Volunteer Local Candidate Researcher</option>
                      <option>Ultralocal BFED Candidate Researcher</option>
                      <option>News Contractor</option>
                      <option>State Legislation Contractor</option>
                      <option>School Research Contractor</option>
                      <option>Candidate Endorsements Staging Contractor</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="form-group" align="center">
        <button class="btn btn-default submit-btn mt-5 mb-5" @click="addNewUserForm">
          Add additional user
        </button>
        <button class="btn btn-default submit-btn mt-5 mb-5" @click="submitUsers()">
          Submit users
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "./shared/Modal";

export default {
  name: "CreateUser",
  components: {
    Modal,
  },
  data() {
    return {
      users: [
        {
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          userType: "",
        },
      ],
      loading: false,
      visible: false,
      resultMessage: "",
    };
  },
   methods: {
    addNewUserForm() {
      this.users.push({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        userType: "",
      });
    },
    deleteUserForm(index) {
      this.users.splice(index, 1);
    },
    async submitUsers() {
      this.resultMessage = "";
      this.loading = true;
      let resultsArray = new Array();
      let results;
      // validate all of the entries
      for await (const user of this.users) {
        if (!user.last_name || !user.email || !user.password || !user.userType) {
          this.resultMessage = "All fields must be supplied to create a user.";
          this.visible = true;
          this.loading = false;
          return;
        }
      }
      //when all are good do the update
      for await (const user of this.users) {
        results = await this.registerUser(user);
      }

      this.loading = false;
      this.visible = true;
    },
    async registerUser(user) {
      let body = {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        password: user.password
      };

      // figure out database role based on form input
      // "api" is prepended to these role names in the API4 endpoint
      if (user.userType === "Local Candidate Researcher") {
        body.role = "local_candidate_researcher";
      } else if (user.userType === "Local Candidate Campaign Themes Researcher") {
        body.role = "local_campaign_themes_researcher";
      } else if (user.userType === "Local Candidate Endorsement Researcher") {
        body.role = "local_candidate_endorsements_volunteer";
      } else if (user.userType === "Volunteer Local Candidate Researcher") {
        body.role = "volunteer_local_candidate_researcher";
      } else if (user.userType === "Ultralocal BFED Candidate Researcher") {
        body.role = "ul_bfed_candidate_researcher";
      } else if (user.userType === 'News Contractor') {
        body.role = "news_contractor";
      } else if (user.userType === 'State Legislation Contractor') {
        body.role = "state_legislation_contractor";
      } else if (user.userType === 'School Research Contractor') {
        body.role = "school_research_contractor";
      } else if (user.userType === 'Candidate Endorsements Staging Contractor') {
        body.role = "candidate_endorsements_staging_contractor";
      } else {
        body.role = "reader";
      }

      body = JSON.stringify(body);

      let headers = { "Content-Type": "application/json", Accept: "application/json" };
      if (user.userType === "Bulk Data Sales Client") {
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/register`;
      } else {
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/register`;
      }

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: "include",
        body: body,
      });

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json();

        this.loading = false;

        if (response.success === false) {
          this.success = false;
          this.resultMessage = `${this.resultMessage} \n Failed: ${response.message}`;
        } else if (response.success) {
          this.success = true;
          this.resultMessage = `${this.resultMessage} \n Success: ${response.message}`;
        }

        return response;
      }
    },
  },
};
</script>

<style>
.submit-btn {
  width: 48%;
  background-color: #3498db;
  color: white;
  font-weight: 600;
}
.float-right {
  float: right;
}
</style>
